import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/font-family.scss'; 
import './scss/veraible.scss';
import './scss/header.scss'; 
import './scss/footer.scss'; 
import './scss/index.scss';

import App from './App'; 
import reportWebVitals from './reportWebVitals'; 
import { Provider } from 'react-redux'; // Import Provider
import store from './store/store'; // Import your store
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import styles
import 'react-loading-skeleton/dist/skeleton.css'; // Skeleton styles


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
    <ToastContainer />
  </Provider>
);

reportWebVitals();